import ComponentInit from './utils/ComponentInit';
import LocationListing from '4-sections/FilteredListings/MapAndListing/MapAndListing';

// Format:
// data-component-name: ComponentFunction
// we shall order these in page load critical first
const componentList = { LocationListing };

export default ComponentInit(componentList);
